<template>
  <div>
    <sidebar-item
      :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: {name: 'auditor.dashboard'},
          }"
    />
    <sidebar-item
      :material=true
      :link="{
            name: $t('sidebar.users'),
            icon: 'group',
            path: {name: 'auditor.user'},
            isRoute: false,
          }"
    />
    <sidebar-item
      :link="{
            name: $t('sidebar.purchase_order'),
            icon: 'tim-icons icon-cart',
          }">
      <sidebar-item
        :link="{
            name: $t('sidebar.charts'),
            path: {name: 'auditor.purchase_order_board'}
          }">
      </sidebar-item>
      <sidebar-item
        :link="{
            name: $t('sidebar.add'),
            icon: 'tim-icons icon-cart',
            path: {name: 'auditor.purchase_order_create'}

          }">
      </sidebar-item>
      <sidebar-item
        :link="{
            name: $t('sidebar.purchase_order'),
            icon: 'tim-icons icon-cart',
            path: {name: 'auditor.purchase_order'}

          }">
      </sidebar-item>
      <sidebar-item
        :link="{
            name: $t('sidebar.import'),
            icon: 'tim-icons icon-cloud-upload-94',
            path: {name: 'auditor.imports'}
          }">
      </sidebar-item>
      <sidebar-item
        :link="{
            name: $t('sidebar.exports'),
            icon: 'tim-icons icon-notes',
            path: {name: 'auditor.purchase_order_exports'}
          }">
      </sidebar-item>
    </sidebar-item>
  </div>
</template>

<script>
    export default {
        name: "sidebar"
    }
</script>

<style scoped>

</style>
